<template>
  <div>
    <h4 class="mb-3">Headers HTTP personalizados</h4>

    <!-- Headers por defecto (solo lectura) -->
    <div v-if="Object.keys(defaultHeaders).length > 0" class="mb-4">
      <v-subheader class="px-0">Headers por defecto</v-subheader>
      <v-chip
        v-for="(value, key) in defaultHeaders"
        :key="`default-${key}`"
        small
        class="mr-2 mb-2"
        color="grey lighten-2"
      >
        <strong>{{ key }}:</strong>&nbsp;{{ value }}
      </v-chip>
    </div>

    <!-- Headers personalizados -->
    <div>
      <v-subheader class="px-0">
        Headers adicionales
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="addHeader">
          <v-icon small left>mdi-plus</v-icon>
          Agregar header
        </v-btn>
      </v-subheader>

      <v-list v-if="headersList.length > 0" dense class="mb-2">
        <v-list-item v-for="(header, index) in headersList" :key="index">
          <v-list-item-content>
            <v-row no-gutters>
              <v-col cols="12" md="5">
                <v-text-field
                  v-model="header.key"
                  label="Nombre del header"
                  placeholder="X-Custom-Header"
                  @input="updateHeaders"
                  dense
                  outlined
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="pl-md-2">
                <v-text-field
                  v-model="header.value"
                  label="Valor"
                  placeholder="valor-del-header"
                  @input="updateHeaders"
                  dense
                  outlined
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="1" class="pl-md-2 d-flex align-center">
                <v-btn icon small color="error" @click="removeHeader(index)">
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-alert v-else type="info" text dense>
        No hay headers personalizados configurados. Haz clic en "Agregar header"
        para añadir uno.
      </v-alert>
    </div>

    <!-- Headers comunes sugeridos -->
    <div class="mt-4">
      <v-subheader class="px-0">Headers comunes</v-subheader>
      <v-chip
        v-for="suggested in suggestedHeaders"
        :key="suggested.key"
        small
        outlined
        class="mr-2 mb-2"
        @click="addSuggestedHeader(suggested)"
      >
        <v-icon small left>mdi-plus</v-icon>
        {{ suggested.key }}
      </v-chip>
    </div>
  </div>
</template>

<script>
export default {
  name: "WebhookHeadersConfig",
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    defaultHeaders: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      headersList: [],
      suggestedHeaders: [
        { key: "Authorization", value: "Bearer YOUR_TOKEN" },
        { key: "X-API-Key", value: "" },
        { key: "Accept", value: "application/json" },
        { key: "Content-Type", value: "application/json" },
        { key: "X-Webhook-Secret", value: "" },
        { key: "User-Agent", value: "Capital28-Webhook/1.0" }
      ]
    };
  },
  mounted() {
    this.initializeHeaders();
  },
  watch: {
    value: {
      handler(newVal) {
        if (
          JSON.stringify(this.convertToObject(this.headersList)) !==
          JSON.stringify(newVal)
        ) {
          this.initializeHeaders();
        }
      },
      deep: true
    }
  },
  methods: {
    initializeHeaders() {
      // Convertir el objeto de headers a un array para el v-for
      this.headersList = Object.entries(this.value).map(([key, value]) => ({
        key,
        value
      }));
    },
    addHeader() {
      this.headersList.push({ key: "", value: "" });
    },
    removeHeader(index) {
      this.headersList.splice(index, 1);
      this.updateHeaders();
    },
    addSuggestedHeader(suggested) {
      // Verificar si ya existe
      const exists = this.headersList.some(h => h.key === suggested.key);
      if (!exists) {
        this.headersList.push({ key: suggested.key, value: suggested.value });
        this.updateHeaders();
      }
    },
    updateHeaders() {
      // Convertir el array a objeto y emitir
      const headersObject = this.convertToObject(this.headersList);
      this.$emit("input", headersObject);
    },
    convertToObject(headersList) {
      const obj = {};
      headersList.forEach(header => {
        if (header.key && header.key.trim()) {
          obj[header.key] = header.value;
        }
      });
      return obj;
    }
  }
};
</script>
